import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.concat.js";
import styled, { css } from "styled-components";
import { formatColorToRgba } from "../core/helpers/formatColorToRgba";
import { colors, display, flexbox, margins, paddings, sizes, text } from "../core/enhancers";

var convertToRgbaMemo = function convertToRgbaMemo() {
  var cached = {};
  return function (color) {
    if (!cached[color]) {
      cached[color] = formatColorToRgba(color, 0.2);
      return cached[color];
    }

    return cached[color];
  };
};

var convertToRgba = convertToRgbaMemo();

var resetUserAgentButtonStyles = function resetUserAgentButtonStyles(_ref) {
  var as = _ref.as;

  if (as === "button") {
    return css(["border:0;margin:0;padding:0;border-radius:0;background-color:transparent;appearance:none;-webkit-tap-highlight-color:transparent;font-family:inherit;font-weight:inherit;"]);
  }

  return css([""]);
};
/* TLinkStyledFC - переопределяем, чтобы стайлед не подсовывал типы нативных атрибутов */


export var LinkStyled = styled.a.withConfig({
  displayName: "Linkstyles__LinkStyled",
  componentId: "sc-1xo7cu-0"
})(function (_ref2) {
  var theme = _ref2.theme,
      hover = _ref2.hover,
      visited = _ref2.visited,
      color = _ref2.color,
      underline = _ref2.underline,
      underlineColor = _ref2.underlineColor,
      size = _ref2.size,
      as = _ref2.as;
  var _theme$componentsToke = theme.componentsTokens.link,
      baseTokens = _theme$componentsToke.base,
      borderWidth = _theme$componentsToke.borderWidth,
      hoverTokens = _theme$componentsToke.hover,
      visitedTokens = _theme$componentsToke.visited,
      focus = _theme$componentsToke.focus,
      active = _theme$componentsToke.active,
      asButton = _theme$componentsToke.asButton;
  return css(["", ";outline-offset:0;cursor:pointer;text-decoration:none !important;border-bottom:", " solid;font-family:", ";font-size:inherit;line-height:inherit;", " ", ";color:", ";border-color:", ";", " &:hover{color:", ";border-color:", ";}&:active{", "}&:focus{", ";}", " ", ";", ";", ";", ";", ";", ";"], resetUserAgentButtonStyles({
    as: as
  }), borderWidth, theme.font.fontFamily, size && css(["font-size:", ";line-height:", ";"], theme.font.sizes[size].fontSize, theme.font.sizes[size].lineHeight), colors, function () {
    if (hover) {
      return hoverTokens.textColor;
    }

    if (visited) {
      return visitedTokens.textColor;
    }

    if (!color) {
      return baseTokens.textColor;
    }

    return "";
  }, function () {
    if (underline === "none" || underline === "hover") {
      return "transparent";
    }

    if (hover) {
      return hoverTokens.borderColor;
    }

    if (visited) {
      return visitedTokens.borderColor;
    }

    if (underlineColor) {
      return convertToRgba(underlineColor);
    }

    return baseTokens.borderColor;
  }, visited !== false && css(["&:visited{color:", ";border-color:", ";}"], visitedTokens.textColor, visitedTokens.borderColor), hoverTokens.textColor, underline === "none" ? "transparent" : hoverTokens.borderColor, active ? css(["color:", ";border-color:", ";"], active.textColor, underline === "none" ? "transparent" : active.borderColor) : "", focus && "outline: ".concat(focus.borderWidth, " solid ").concat(focus.focusBorderColor), as === "button" && css(["&:disabled{cursor:default;pointer-events:none;", ";", ";", ";}", ";"], asButton.disabledStyle.opacity && "opacity: ".concat(asButton.disabledStyle.opacity), asButton.disabledStyle.textColor && "color: ".concat(asButton.disabledStyle.textColor), asButton.disabledStyle.borderColor && "border-color: ".concat(asButton.disabledStyle.borderColor), asButton.borderStyle && "border-style:".concat(asButton.borderStyle)), flexbox, margins, paddings, display, sizes, text);
});